module.exports = __webpack_public_path__ + "img/305a49b.svg";